type Theme = {
  '--bg-color': string
  '--white': string
  '--black': string
  '--grey': string
  '--bg-darker': string
  '--link': string
  '--shadow-color': string
  '--bg-transparent': string
  '--theme-color': string
  '--primary': string
  '--shadow': string
  '--text-color': string
  '--shadow-db': string
  '--card-shadow': string
  '--accent': string
}

export const dark: Theme = {
  '--bg-color': '#252525',
  '--white': '#fff',
  '--black': '#010101',
  '--grey': 'rgba(221, 221, 221, 0.692)',
  '--bg-darker': '#111111',
  '--link': '#a1a1a1',
  '--shadow-color': '#222',
  '--bg-transparent': 'rgba(0, 0, 0, 0.2)',
  '--theme-color': '#f57f17',
  '--primary': 'rgb(201, 202, 206)',
  '--shadow': '2px 3px 4px var(--black)',
  '--text-color': 'rgba(231, 231, 231, 0.959)',
  '--shadow-db': '2px 2px 2px rgba(153, 153, 153, 0.2)',
  '--card-shadow': '0px 2px 4px 2px var(--shadow-color)',
  '--accent': 'green',
}

export const light: Theme = {
  '--bg-color': '#ffffff',
  '--white': 'rgb(255, 255, 255)',
  '--black': '#000000',
  '--grey': '#d2d2d2',
  '--bg-darker': '#ddd7ff',
  '--link': '#292929',
  '--shadow-color': '#d0cbcb',
  '--bg-transparent': 'rgba(0, 0, 0, 0.2)',
  // '--theme-color': '#ffe140',
  '--theme-color': 'rgba(245, 127, 23, 1)',
  '--primary': 'rgb(201, 202, 206)',
  '--shadow': '2px 3px 4px var(--shadow-color)',
  '--text-color': 'rgba(29, 28, 28, 0.959)',
  '--shadow-db': '2px 2px 2px rgba(153, 153, 153, 0.2)',
  '--card-shadow': '0px 2px 4px 2px var(--shadow-color)',
  '--accent': '#26bbd8',
}

export const getThemeVal = (theme: Theme, prop: string): string => {
  switch (prop) {
    case '--bg-color':
      return theme['--bg-color']
    case '--white':
      return theme['--white']
    case '--black':
      return theme['--black']
    case '--grey':
      return theme['--grey']
    case '--bg-darker':
      return theme['--bg-darker']
    case '--link':
      return theme['--link']
    case '--shadow-color':
      return theme['--shadow-color']
    case '--bg-transparent':
      return theme['--bg-transparent']
    case '--theme-color':
      return theme['--theme-color']
    case '--primary':
      return theme['--primary']
    case '--shadow':
      return theme['--shadow']
    case '--text-color':
      return theme['--text-color']
    case '--shadow-db':
      return theme['--shadow-db']
    case '--card-shadow':
      return theme['--card-shadow']
    case '--accent':
      return theme['--accent']
    default:
      return ''
  }
}
